<template>
    <div>
        <div class="field is-horizontal">
            <div class="field-body">
                <button
                    class="button control is-ghost has-text-danger"
                    @click="$emit('remove')"
                >
                    <span class="icon">
                        <i class="mdi mdi-24px mdi-delete"></i>
                    </span>
                </button>
                <div class="field has-addons">
                    <div class="control is-expanded">
                        <input
                            v-model="sourceAnswer.value"
                            :placeholder="$t('creation.answer_hint')"
                            class="input"
                            type="text"
                            @change="addAnswer"
                        />
                    </div>
                </div>
                <div v-if="answerType == 'MULTIPLE' || answerType == 'SINGLE'">
                    <label class="switch">
                        <input
                            v-model="sourceAnswer.correct"
                            :disabled="disableSwitch"
                            type="checkbox"
                            @change="addAnswer"
                        />
                        <span class="slider round"></span>
                    </label>
                    <!--vb-switch
          
            v-model="sourceAnswer.correct"
            size="medium"
            type="primary"
            @change="addAnswer"
          /-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InputAnswer',
    components: {},
    model: {
        prop: 'sourceAnswer',
    },
    props: {
        sourceAnswer: {
            type: Object,
            default: () => {
                return {};
            },
        },
        answerType: {
            type: String,
            default: () => {
                return '';
            },
        },
        disableSwitch: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
    },
    data() {
        return {
            checkValue: undefined,
            answer: this.sourceAnswer,
        };
    },
    methods: {
        addAnswer() {
            if (this.answerType == 'HANGMAN' || this.answerType == 'FREETEXT') {
                this.sourceAnswer.correct = true;
            }
            this.$emit('input', this.sourceAnswer);
        },
    },
};
</script>

<style scoped></style>
